import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';

class InternalAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'Business';
  controllerName = 'internals';

  /**
   * Thực hiện 1 số hành động khác sau login
   * NXPHONG 11/12/2024
   */
  async executeAfterLogin() {
    const request = {
      url: [this.getAPIUrl(), 'execute-after-login'].join('/'),
    };
    return httpClient.getAsync(request);
  }
  /**
   * xác nhận thỏa thuận mua hàng
   * NXPHONG 11/12/2024
   */
  async acceptAgreementTermsPrivacy() {
    const request = {
      url: [this.getAPIUrl(), 'agreements-purchase'].join('/'),
    };
    return this.postAsync(request);
  }
  /**
   * Lấy lịch sử thỏa thuận hoặc chính sách
   * @param {*} payload
   * NXPHONG 11/12/2024
   */
  async getHistoryAgreement(payload) {
    const request = {
      url: [this.getAPIUrl(), 'history-agreement'].join('/'),
      data: payload,
    };
    return this.postAsync(request);
  }

  async getApplicationQuickLauncher(payload) {
    const request = {
      url: [this.getAPIUrl(), 'application-quick-launcher'].join('/'),
      data: payload,
    };
    return this.getAsync(request);
  }
}

export default new InternalAPI();
